"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTreeData = void 0;

var data_1 = require("@react-stately/data");

function useTreeData(items, keyName, childrenName) {
  return (0, data_1.useTreeData)({
    initialItems: items,
    getKey: function getKey(item) {
      return item[keyName !== null && keyName !== void 0 ? keyName : 'id'];
    },
    getChildren: function getChildren(item) {
      var _a;

      return (_a = item[childrenName !== null && childrenName !== void 0 ? childrenName : 'children']) !== null && _a !== void 0 ? _a : [];
    }
  });
}

exports.useTreeData = useTreeData;